import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { invalidTrailingComma2uwwnmbqspks2 as invalidTrailingComma } from './JsonExceptions.mjs';
import {
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonArray2urf8ey7u44sd as JsonArray,
  JsonNull_getInstance39w6eplghmtxw as JsonNull_getInstance,
  JsonLiteral1u57id0qmqut7 as JsonLiteral,
} from '../JsonElement.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  DeepRecursiveFunction3r49v8igsve1g as DeepRecursiveFunction,
  invoke246lvi6tzooz1 as invoke,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/DeepRecursive.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { tokenDescription3r6eqmtoxe76u as tokenDescription } from './AbstractJsonLexer.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readObject($this) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.x2s_1.b2t(6);
  if ($this.x2s_1.c2t() === 4) {
    $this.x2s_1.w2r('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap().ec();
  $l$loop: while ($this.x2s_1.d2t()) {
    var key = $this.y2s_1 ? $this.x2s_1.f2t() : $this.x2s_1.e2t();
    $this.x2s_1.b2t(5);
    var element = $this.g2t();
    // Inline function 'kotlin.collections.set' call
    result.x4(key, element);
    lastToken = $this.x2s_1.h2t();
    var tmp0_subject = lastToken;
    if (tmp0_subject !== 4)
      if (tmp0_subject === 7)
        break $l$loop;
      else {
        $this.x2s_1.w2r('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.x2s_1.b2t(7);
  } else if (lastToken === 4) {
    if (!$this.z2s_1) {
      invalidTrailingComma($this.x2s_1);
    }
    $this.x2s_1.b2t(7);
  }
  return new (JsonObject())(result);
}
function *readObject_0($this, $receiver, $completion) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.x2s_1.b2t(6);
  if ($this.x2s_1.c2t() === 4) {
    $this.x2s_1.w2r('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap().ec();
  $l$loop: while ($this.x2s_1.d2t()) {
    var key = $this.y2s_1 ? $this.x2s_1.f2t() : $this.x2s_1.e2t();
    $this.x2s_1.b2t(5);
    var element = yield* $receiver.xs(Unit_instance, $completion);
    // Inline function 'kotlin.collections.set' call
    result.x4(key, element);
    lastToken = $this.x2s_1.h2t();
    var tmp0_subject = lastToken;
    if (tmp0_subject !== 4)
      if (tmp0_subject === 7)
        break $l$loop;
      else {
        $this.x2s_1.w2r('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.x2s_1.b2t(7);
  } else if (lastToken === 4) {
    if (!$this.z2s_1) {
      invalidTrailingComma($this.x2s_1);
    }
    $this.x2s_1.b2t(7);
  }
  return new (JsonObject())(result);
}
function readArray($this) {
  var lastToken = $this.x2s_1.h2t();
  if ($this.x2s_1.c2t() === 4) {
    $this.x2s_1.w2r('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.arrayListOf' call
  var result = ArrayList().p2();
  while ($this.x2s_1.d2t()) {
    var element = $this.g2t();
    result.i2(element);
    lastToken = $this.x2s_1.h2t();
    if (!(lastToken === 4)) {
      var tmp0 = $this.x2s_1;
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
      var condition = lastToken === 9;
      var position = tmp0.g2m_1;
      if (!condition) {
        var tmp$ret$2 = 'Expected end of the array or comma';
        tmp0.w2r(tmp$ret$2, position);
      }
    }
  }
  if (lastToken === 8) {
    $this.x2s_1.b2t(9);
  } else if (lastToken === 4) {
    if (!$this.z2s_1) {
      invalidTrailingComma($this.x2s_1, 'array');
    }
    $this.x2s_1.b2t(9);
  }
  return new (JsonArray())(result);
}
function readValue($this, isString) {
  var tmp;
  if ($this.y2s_1 || !isString) {
    tmp = $this.x2s_1.f2t();
  } else {
    tmp = $this.x2s_1.e2t();
  }
  var string = tmp;
  if (!isString && string === 'null')
    return JsonNull_getInstance();
  return new (JsonLiteral())(string, isString);
}
function readDeepRecursive($this) {
  return invoke(new (DeepRecursiveFunction())(JsonTreeReader$readDeepRecursive$slambda($this)), Unit_instance);
}
function JsonTreeReader$readDeepRecursive$slambda(this$0) {
  return constructCallableReference(function *($this$DeepRecursiveFunction, it, $completion) {
    var tmp0_subject = this$0.x2s_1.c2t();
    var tmp;
    if (tmp0_subject === 1) {
      tmp = readValue(this$0, true);
    } else if (tmp0_subject === 0) {
      tmp = readValue(this$0, false);
    } else if (tmp0_subject === 6) {
      tmp = yield* /*#__NOINLINE__*/readObject_0(this$0, $this$DeepRecursiveFunction, $completion);
    } else if (tmp0_subject === 8) {
      tmp = readArray(this$0);
    } else {
      this$0.x2s_1.w2r("Can't begin reading element, unexpected token");
    }
    return tmp;
  }, 2);
}
var JsonTreeReaderClass;
function JsonTreeReader() {
  if (JsonTreeReaderClass === VOID) {
    class $ {
      constructor(configuration, lexer) {
        this.x2s_1 = lexer;
        this.y2s_1 = configuration.h2n_1;
        this.z2s_1 = configuration.t2n_1;
        this.a2t_1 = 0;
      }
      g2t() {
        var token = this.x2s_1.c2t();
        var tmp;
        if (token === 1) {
          tmp = readValue(this, true);
        } else if (token === 0) {
          tmp = readValue(this, false);
        } else if (token === 6) {
          var tmp_0;
          this.a2t_1 = this.a2t_1 + 1 | 0;
          if (this.a2t_1 === 200) {
            tmp_0 = readDeepRecursive(this);
          } else {
            tmp_0 = readObject(this);
          }
          var result = tmp_0;
          this.a2t_1 = this.a2t_1 - 1 | 0;
          tmp = result;
        } else if (token === 8) {
          tmp = readArray(this);
        } else {
          this.x2s_1.w2r('Cannot read Json element because of unexpected ' + tokenDescription(token));
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'JsonTreeReader', VOID, VOID, VOID, [1]);
    JsonTreeReaderClass = $;
  }
  return JsonTreeReaderClass;
}
//region block: exports
export {
  JsonTreeReader as JsonTreeReader1ycreu77eikqj,
};
//endregion

//# sourceMappingURL=JsonTreeReader.mjs.map
